import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, getFormValues } from 'redux-form';
import { withRouter } from 'react-router';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { updateProsperityPath } from '../../../../../../reducers/prosperity';
import { updatePaginationPreviousRoute } from '../../../../../../reducers/calculator';
import { onSubmit } from '../../../../../common/components/submit-button';
import { Link } from 'react-router-dom';
import { trackingEvent } from '../../../../../helpers/tracking';

const trackingFinancial = {
    eventAction: 'Prosperity Planner - Step 4',
    eventLabel: 'Path to Prosperity - Assess My Finances'
};

const trackingGoals = {
    eventAction: 'Prosperity Planner - Step 4',
    eventLabel: 'Path to Prosperity - Set Goals'
};

export const formName = Routes.STEPFOUR;
const slug = `${process.env.PUBLIC_URL}/prosperity-planner`;

export const formDetails = {
    key: 'pathToProsperity',
    title: 'Choose Your Path To Prosperity',
    formName,
    totalKey: 'pathToProsperity',
    fields: {
        finances: {
            label: 'Assess My Finances',
            link: `${slug}${Routes.STEPFIVE}`,
            skipFinancial: false
        },
        goals: {
            label: 'Set Goals',
            link: `${slug}${Routes.STEPNINE}`,
            skipFinancial: true
        }
    }
};

const minValue = 0;

class StepFourForm extends Component {
    render() {
        const {
            updateProsperityPath,
            updatePaginationPreviousRoute
        } = this.props;
        return (
            <form className={styles.form}>
                {
                    Object.keys(formDetails.fields).map(key =>
                        <Link
                            key={key}
                            to={formDetails.fields[key].link}
                            onClick={() => {
                                updateProsperityPath(formDetails.fields[key].skipFinancial);
                                updatePaginationPreviousRoute(Routes.STEPFOUR);
                                key === 'finances' && trackingEvent(trackingFinancial);
                                key === 'goals' && trackingEvent(trackingGoals);
                            }}
                            className={styles.ctaButton}
                            title={formDetails.fields[key].label}
                        >
                            {formDetails.fields[key].label}
                        </Link>
                    )
                }
            </form>
        );
    }
}

const formValues = getFormValues(formName);

const mapStateToProps = (state) => ({
    formValues: formValues(state),
    paginationSkipState: state.calculator.paginationHasSkip,
    prosperityPath: state.prosperity.skipFinancial,
});

const mapDispatchToProps = (dispatch) => ({
    updateProsperityPath: dispatch(updateProsperityPath),
    updatePaginationPreviousRoute: dispatch(updatePaginationPreviousRoute),
});

StepFourForm = reduxForm({
    form: formName,
    destroyOnUnmount: false,
    onSubmit,
    initialValues: Object.keys(formDetails.fields).reduce((obj, val) => ({
        ...obj,
        [val]: minValue
    }), {}),
    skipPath: `/prosperity-planner${Routes.SUMMARY}`,
    redirectPath: `/prosperity-planner${Routes.STEPFIVE}`
}, mapStateToProps, mapDispatchToProps)(StepFourForm);

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(StepFourForm));
